module.exports = {"370113001":"文昌街道","370113002":"崮云湖街道","370113003":"平安街道","370113004":"五峰山街道","370113101":"归德镇","370113102":"孝里镇","370113103":"万德镇","370113106":"张夏镇","370113107":"马山镇","370113108":"双泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370113.json
// module id = 1255
// module chunks = 0